import { createContext, useContext } from "react";
import type { TownSession } from "./townSession";

/** The live town session (null outside the town layout, before bootstrap, or in 2D fallback). */
export const TownSessionContext = createContext<TownSession | null>(null);

export function useTownSession(): TownSession | null {
  return useContext(TownSessionContext);
}
